module.exports = __webpack_public_path__ + "static/illustration-5128b90ffd8b181438e58cd94ffa6d72.png";